import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader, TranslocoLoaderData } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(langOrScopePath: string, data?: TranslocoLoaderData) {
    const path = this.resolveTranslationPath(langOrScopePath, data);
    return this.http.get<Translation>(`/i18n/${path}.json?v=${Date.now()}`);
  }

  private resolveTranslationPath(langOrScopePath: string, data?: TranslocoLoaderData): string {
    if (langOrScopePath.includes('/')) {
      return langOrScopePath;
    }
    if (data?.scope) {
      return `${data.scope}/${langOrScopePath}`;
    }
    return langOrScopePath;
  }
}
